module.exports = __webpack_public_path__ + "static/media/Indonesia Book Party - Green Transparent.3ee3fe58.png";